var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.offers),function(product,index){return _c(`extra-service-card${_vm.$breakpoint.smAndDown ? '-mobile' : ''}`,{key:product.info.name,tag:"component",staticClass:"my-2",attrs:{"product":product,"data-cy":`extra-service-offer-${index}`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }